export default __webpack_public_path__ + "static/media/UBMe Playstore.ce4fd272.png";